module.exports = __webpack_public_path__ + "static/media/logopng.d28708ba.png";